import { render, staticRenderFns } from "./TextSidebar.vue?vue&type=template&id=71281a86&scoped=true"
import script from "./TextSidebar.vue?vue&type=script&lang=js"
export * from "./TextSidebar.vue?vue&type=script&lang=js"
import style0 from "./TextSidebar.vue?vue&type=style&index=0&id=71281a86&prod&lang=css"
import style1 from "./TextSidebar.vue?vue&type=style&index=1&id=71281a86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71281a86",
  null
  
)

export default component.exports